import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["typeValue"]
  static values = {
    eventName: { type: String, default: "checkout-modal-closed" }
  }

  connect() {
    this.boundHandleModalClose = this.handleModalClose.bind(this)
    this.element.addEventListener('hidden.bs.modal', this.boundHandleModalClose)
  }

  disconnect() {
    this.element.removeEventListener('hidden.bs.modal', this.boundHandleModalClose)
  }

  handleModalClose(event) {
    const modalElement = event.target

    if (!modalElement.classList.contains('modal')) {
      return
    }

    const typeElement = modalElement.querySelector('[data-modal-tracking-target="typeValue"]')
    const modalType = typeElement.dataset.type
    this.trackClose(modalType)
  }

  trackClose(modalType) {
    const eventData = {
      event_name: this.eventNameValue,
      properties: {
        modal_type: modalType,
      }
    }

    this.sendTrackingEvent(eventData)
  }

  sendTrackingEvent(eventData) {
    fetch('/checkout/posthog_events', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-CSRF-Token': this.csrfToken
      },
      body: JSON.stringify(eventData)
    }).catch(error => {
      console.error('Failed to track modal close:', error)
    })
  }

  get csrfToken() {
    const meta = document.querySelector('meta[name="csrf-token"]')
    return meta ? meta.content : ''
  }
}
